import { headingTextItems, linkTo } from "querypieces";

export default `
  programDifferences: ${headingTextItems}
  ${linkTo}
`;
